import { useEffect } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router";
import * as theme from '../theme';

export default function SignOut() {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/");
  };

  useEffect(() => {
    handleSignOut();
  }, []);

  return (
    <div style={theme.Container.basic}>
      <div style={theme.Heading}>Signing Out</div>
      <div style={theme.SubText}>We are signing you out of your account. The nex time you visit the app you will need to login again.</div>
    </div>
  );
}